import { useContext } from "react";
import { ScrollContext } from "../../Context/ScrollContext";

const About = () => {
  const { AboutRef } = useContext(ScrollContext);

  return (
    <div id="about" className="main-content-div" ref={AboutRef}>
      <h1>About</h1>
      <h3>
        {" "}
        Creative, detail-oriented, software developer with a deep interest in
        AI. Proven track record of creating and implementing successful front
        and back end web applications. Looking to bring my skills to a tech
        company with global reach.{" "}
      </h3>
    </div>
  );
};

export default About;
